export const LanguageKey = {
    ENGLISH: 'en',
    SPANISH: 'es',
    GERMAN: 'de',
    FRENCH: 'fr',
    ITALIAN: 'it',
    PORTUGUESE: 'pt',
    RUSSIAN: 'ru',
    TURKISH: 'tr',
    DUTCH: 'nl',
    POLISH: 'pl',
    VIETNAMESE: 'vi',
    BRAZILIAN: 'br',
} as const;
export type LanguageKey = typeof LanguageKey[keyof typeof LanguageKey];

export const defaultLanguageKey: LanguageKey = LanguageKey.ENGLISH;
export const fallbackLanguageKey: LanguageKey = LanguageKey.ENGLISH;
